import { Heading, Paragraph } from '@ndlib/component-library'
import React from 'react'
// write a functional component that will display the video content that takes three strings as props
interface VideoContentProps {
  videoTitle: string
  videoUrl: string
  videoDescription: string

}

const VideoContent: React.FC<VideoContentProps> = ({ videoTitle, videoUrl, videoDescription }) => {
  if (!videoUrl) {
    return null
  }
  return (
    <div>
      {videoTitle && <Heading level={2}>{videoTitle}</Heading>}
      <div>
        <iframe
          width="780"
          height="540"
          src={youTubeEmbedUrl(videoUrl)}
          title={videoTitle}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      {videoDescription && <Paragraph>{videoDescription}</Paragraph>}
    </div>
  )
}

export default VideoContent

const extractYouTubeVideoId = (url: string): string | null => {
  const regex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  const match = url.match(regex)
  return match ? match[1] : null
}
const youTubeEmbedUrl = (videoRawUrl: string): string => {
  return `https://www.youtube.com/embed/${extractYouTubeVideoId(videoRawUrl)}`
}